//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import { MODES } from './RequestWorkTypeReportInclusionMode.js'

export default {
  name: 'RequestWorkTypeReportInclusionModeEditor',
  components: {
    // Чтобы избежать рекурсивности
    RequestWorkTypeListElement: () => import('./RequestWorkTypeListElement.vue')
  },
  props: {
    workType: {
      type: Object,
      required: true
    },
    workTypeInitial: {
      type: Object,
      default () {
        return null
      }
    },
    request: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      selectedMode: null,
      modes: MODES,
      workTypeLocal: JSON.parse(JSON.stringify(this.workType)),

      applyToCurrentReport: false,

      showHints: false
    }
  },
  computed: {
    ...mapGetters({
      workTypes: 'getWorkTypes'
    }),
    isIncludedInCurrentReport: function () {
      return this.workTypeInitial ? this.workTypeInitial.includedInCurrentReport : false
    },
    isDone: function () {
      return this.workType.done || this.workType.donePartially
    },
    hasNotReadyReport: function () {
      return this.request.hasNotReadyReport
    },
    applyToCurrentReportAvailable: function () {
      if (!this.selectedMode) {
        return false
      }
      if (this.selectedMode.key === 'stopped') {
        return this.hasNotReadyReport && this.isIncludedInCurrentReport && !this.isDone
      } else {
        return this.hasNotReadyReport && !this.isIncludedInCurrentReport
      }
    },
    applyCurrentReportCaption: function () {
      if (!this.selectedMode) {
        return 'Выберите режим, чтобы увидеть, какие работы будут добавлены или удалены из текущего отчета'
      }
      if (!this.hasNotReadyReport) {
        return 'Отсутствует несданный отчёт по текущему выезду.'
      }
      if (this.isIncludedInCurrentReport) {
        if (this.isDone) {
          return 'Отчёт по текущему выезду содержит данную работу и у нее есть результаты выполнения'
        } else {
          return 'Отчёт по текущему выезду содержит данную работу, но у нее нет результатов выполнения'
        }
      } else {
        return 'Отчёт по текущему выезду не содержит данную работу.'
      }
    },
    applyToCurrentReportLabel: function () {
      if (!this.selectedMode) {
        return 'Применить к текущему выезду'
      }
      if (this.selectedMode.key === 'stopped') {
        return 'Удалить из текущего выезда'
      } else {
        return 'Добавить в текущий выезд'
      }
    },
    defaultMode: function () {
      const defaultWorkType = this.workTypes.find(wT => wT.id === this.workType.id)
      return this.modes.find(mode => mode.active(defaultWorkType))
    }
  },
  watch: {
    workType: {
      handler: function (value) {
        this.workTypeLocal = JSON.parse(JSON.stringify(value))
      },
      deep: true
    }
  },
  created: function () {
    const activeMode = this.modes.find(mode => mode.active(this.workType))
    if (activeMode) {
      this.selectedMode = activeMode
      if (this.selectedMode.key === 'stopped') {
        if (this.isIncludedInCurrentReport && !this.isDone) {
          this.applyToCurrentReport = !this.workType.includedInCurrentReport
        }
      } else if (!this.isIncludedInCurrentReport) {
        this.applyToCurrentReport = this.workType.includedInCurrentReport
      }
    }
  },
  methods: {
    onSelectMode: function (mode) {
      if (this.selectedMode && this.selectedMode.key === mode.key) {
        this.selectedMode = null
      } else {
        this.selectedMode = mode
        if (this.selectedMode.key === 'stopped') {
          if (this.isIncludedInCurrentReport && !this.isDone) {
            this.applyToCurrentReport = !this.workType.includedInCurrentReport
          }
        } else if (!this.isIncludedInCurrentReport) {
          this.applyToCurrentReport = this.workType.includedInCurrentReport
        }
      }
    },
    onSaveSelection: function () {
      this.selectedMode.set(this.workTypeLocal)
      if (this.selectedMode.key === 'stopped' && (!this.isIncludedInCurrentReport || this.isDone)) {
        this.workTypeLocal.includedInCurrentReport = this.isIncludedInCurrentReport
      } else if (this.selectedMode.key !== 'stopped' && this.isIncludedInCurrentReport) {
        this.workTypeLocal.includedInCurrentReport = this.isIncludedInCurrentReport
      } else {
        if (this.selectedMode.key === 'stopped') {
          this.workTypeLocal.includedInCurrentReport = !this.applyToCurrentReport
        } else {
          this.workTypeLocal.includedInCurrentReport = this.applyToCurrentReport
        }
      }
      this.$emit('select', this.workTypeLocal)
    }
  }
}

